// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { xBaseTheme } from "@keller/XDL/types";
import { color } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            src: "ChevronDown",
            size: 14,
            css: css`
                color: ${color("common.ui7")};
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
        cssOverrides: {
            dropdownWrapper: css`
                & input[aria-expanded="true"] ~ ${IconWrapper} {
                    transform: rotate(180deg);
                }
                & input ~ ${IconWrapper}:not(:disabled):hover {
                    color: ${color("common.ui7")};
                }
                & input:disabled ~ ${IconWrapper} {
                    color: ${color("common.ui7", 0.33)};
                    background: transparent;
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
